import { useState } from 'react';
import { CreateTicketDialog } from 'shared/components/ticketing';
import { createStandaloneTicket } from 'shared/services/settingsApi';
import { TicketingIntegration } from 'shared/types';

type Props = {
  open: boolean;
  onClose: () => void;
  onTicketCreated: (key: string) => void;
  activeIntegration: TicketingIntegration;
  envId: string;
};

const CreateTicketDialogs = ({
  open,
  onClose,
  onTicketCreated,
  activeIntegration,
  envId,
}: Props) => {
  const [isCreating, setIsCreating] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const handleClose = () => {
    onClose();
    setError(null);
  };

  const handleConfirm = async (customFields?: Record<string, any>) => {
    setIsCreating(true);
    setError(null);
    try {
      const result = await createStandaloneTicket(
        envId,
        activeIntegration.id,
        customFields,
      );
      onTicketCreated(result.ticket.key);
    } catch (e) {
      setError(e instanceof Error ? e : new Error('Failed to create ticket'));
    } finally {
      setIsCreating(false);
    }
  };

  return (
    <CreateTicketDialog
      open={open}
      onClose={handleClose}
      onConfirm={handleConfirm}
      integration={activeIntegration}
      envId={envId}
      isCreating={isCreating}
      error={error}
    />
  );
};

export default CreateTicketDialogs;
